// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import {
  decodedTokenUpdated,
  firstStepFormRequested,
  loggedOut,
  loginError,
  loginFirstStepError,
  loginFirstStepSuccess,
  loginRequested,
  loginSuccess,
  resetPasswordError,
  resetPasswordRequested,
  resetPasswordSuccess,
  tokenRefreshed,
  userRestored,
} from './auth.actions';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DecodedToken } from '../model/decoded-token';

export interface State {
  accessToken?: string;
  refreshToken?: string;
  error?: string;
  isLoading: boolean;
  isCodeRequired: boolean;
  decodedToken?: DecodedToken;
}

const initialState: State = {
  isLoading: false,
  isCodeRequired: false,
};

const reducer = createReducer(
  initialState,
  on(decodedTokenUpdated, (state, {decodedToken}) => ({...state, decodedToken})),
  on(loginRequested, (state) => ({...state, isLoading: true})),
  on(loginSuccess, (state, {accessToken}) => {
    return ({
      ...state,
      isLoading: false,
      isCodeRequired: false,
      decodedToken: new JwtHelperService().decodeToken(accessToken),
    });
  }),

  on(loginError, (state, {error}) => ({...state, error, isLoading: false, isCodeRequired: false})),
  on(loginFirstStepSuccess, (state) => ({...state, isLoading: false, isCodeRequired: true})),
  on(loginFirstStepError, (state) => ({...state, isLoading: false})),
  on(firstStepFormRequested, (state) => ({...state, isCodeRequired: false})),

  on(loggedOut, () => ({...initialState})),
  on(userRestored, (state, {accessToken, refreshToken}) => ({
    ...state,
    accessToken,
    refreshToken,
    decodedToken: new JwtHelperService().decodeToken(accessToken),
  })),
  on(tokenRefreshed, (state, {accessToken, refreshToken}) => ({
    ...state,
    accessToken,
    refreshToken,
    decodedToken: new JwtHelperService().decodeToken(accessToken),
  })),
  on(resetPasswordRequested, (state) => ({...state, isLoading: true})),
  on(resetPasswordSuccess, (state) => ({...state, isLoading: false})),
  on(resetPasswordError, (state, {error}) => ({...state, isLoading: false, error})),

  on(resetPasswordRequested, (state) => ({...state, isLoading: true})),
  on(resetPasswordSuccess, (state) => ({...state, isLoading: false})),
  on(resetPasswordError, (state, {error}) => ({...state, isLoading: false, error})),
);

export function authReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}
